// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
Rails.start()

import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

import Turbolinks from 'turbolinks'
Turbolinks.start()

// Remove stale service workers left over from the removed serviceworker-rails gem.
// Without this, the browser keeps replaying cached POST responses causing ghost requests.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => r.unregister())
  })
}

import '../channels'

// Register companies--v2--menu Stimulus controller on the application pack so pages
// that only include `javascript_pack_tag 'application'` (like checkout) still
// initialize the menu controller and its phone lookup behavior.
import { Application } from '@hotwired/stimulus'
import MenuController from '../controllers/companies/v2/menu_controller'

// Initialize Stimulus application if not present, otherwise attempt safe register
if (!window.Stimulus) {
  const application = Application.start()
  application.register('companies--v2--menu', MenuController)
  window.Stimulus = application
} else {
  try {
    window.Stimulus.register('companies--v2--menu', MenuController)
  } catch (err) {
    // controller might already be registered by v2_menu pack; ignore duplicate
    console.debug('[VIPTable] companies--v2--menu already registered')
  }
}

// Import npm packages and make them globally available for Sprockets assets
import Sortable from 'sortablejs'
import Dropzone from 'dropzone'

window.Sortable = Sortable
window.Dropzone = Dropzone

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
